import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { EncroachmentStatusDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';


@Component({
  selector: 'cradua-encroachmentstatus-container',
  templateUrl: './encroachmentstatus-container.component.html',
  styleUrls: ['./encroachmentstatus-container.component.scss']
})
export class EncroachmentStatusContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  encroachmentstatuss$: Observable<EncroachmentStatusDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("EncroachmentStatus");
    this.encroachmentstatuss$ = this.gatwayFacade.loadGateway("EncroachmentStatus");
    this.encroachmentstatuss$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteEncroachmentStatus(deletedValue: any) {
    this.gatwayFacade.remove("EncroachmentStatus", deletedValue);
    // this.store.dispatch(EncroachmentStatusStoreActions.removeEncroachmentStatus({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitEncroachmentStatus(formValue: any) {
    console.log("form value: ", formValue);
    formValue.EncroachmentStatuss = formValue.EncroachmentStatuss.reverse();
    event.preventDefault();
    const pullData = formValue.EncroachmentStatuss;
    //const newPullData = formValue.EncroachmentStatuses;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllEncroachmentStatus = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllEncroachmentStatus.push(pullData[i]);
    }
  }

// check if the addAllEncroachmentStatus array is not empty, then dispatch the data to the store
   if(addAllEncroachmentStatus.length !== 0) {
    this.gatwayFacade.add('EncroachmentStatus', addAllEncroachmentStatus);
    // this.store.dispatch(EncroachmentStatusStoreActions.addEncroachmentStatus({newEncroachmentStatus: addAllEncroachmentStatus}));

   }

// dispatch update data to the store
this.gatwayFacade.update('EncroachmentStatus', allUpdates, ['id']);
    // this.store.dispatch(EncroachmentStatusStoreActions.updateEncroachmentStatus({updateEncroachmentStatus: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}


